import "es6-shim";
import * as React from 'react';
import { IGenericsLang } from "../../services/Language/Types";
const redDownArrow = require('../../assets/images/red-down-arrow.svg');

interface IScannerProps {
    invalidNumberDetected: boolean
    text: IGenericsLang,
    isSubmittedToServer: boolean,
    submitHealthCardNumber(val: string): void,
    return(): void,
    changeMode(): void
    disableScanning: boolean;
}

interface IScannerState {
    isScanningModeOn: boolean,
    healthCardNumber: string
}

export class Scanner extends React.Component<IScannerProps, IScannerState> {
    constructor(props: IScannerProps) {
        super(props);
        this.processBarCode = this.processBarCode.bind(this);
        this.state = {
            isScanningModeOn: false,
            healthCardNumber: ""
        };
    }

    public componentWillReceiveProps(nextProps:IScannerProps) {
        if (nextProps.isSubmittedToServer !== this.props.isSubmittedToServer && !nextProps.isSubmittedToServer) {
            document.addEventListener('keydown', this.processBarCode);
        }
    }

    public processBarCode(barcode: KeyboardEvent) {
        barcode.preventDefault();
        if (this.props.disableScanning && !this.state.isScanningModeOn)
            return;

        if (!this.state.isScanningModeOn) {
            this.setState({ isScanningModeOn: true }, () => {
                setTimeout(() => {
                    const healthCardNumber = this.state.healthCardNumber;
                    this.setState(
                        { isScanningModeOn: false, healthCardNumber: "" },
                        () => healthCardNumber && this.props.submitHealthCardNumber(healthCardNumber)
                    );
                }, 1000)
            });
        } else if (this.state.isScanningModeOn) {
            const keyCode = barcode.key;
            if ((!barcode.ctrlKey && !barcode.altKey && keyCode !== "Shift" && keyCode !== "Enter"))
                this.setState({ healthCardNumber: this.state.healthCardNumber + barcode.key });
        }
    }

    public componentDidMount() {
        document.addEventListener('keydown', this.processBarCode);
    }

    public componentWillUnmount() {
        document.removeEventListener('keydown', this.processBarCode);
    }

    public render(): JSX.Element {
        const scannerString = this.props.text;
        return (
            <div className="col-sm-12 text-center">

                <div className="row">
                    {this.props.children}
                    <div className="col-sm-12 text-center">
                        <button
                            id="scannerChangeModeButton"
                            className="buttons-white"
                            onClick={() => { this.props.changeMode() }}
                        >
                            {scannerString.labels.ToManualInputModeButton}
                        </button>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <h2>--{scannerString.labels.OrLabel}--</h2>
                        <h1 className="title-instruction">{scannerString.messagesInstructions.UsbBarCodeInstructions}</h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <img src={redDownArrow} style={{ paddingTop: "40px" }} height={"200px"} />
                    </div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/AcquireHealthCardNumber/Scanner.tsx